import { AlertCircle } from "lucide-react";
import { Container, IconContainer, Mensagem, BotaoRetry } from "./styles";

interface HistoricoErroProps {
  onRetry: () => void;
}

export default function HistoricoErro({ onRetry }: HistoricoErroProps) {
  return (
    <Container>
      <IconContainer>
        <AlertCircle size={48} />
      </IconContainer>
      <Mensagem>Ocorreu um erro ao carregar o histórico.</Mensagem>
      <BotaoRetry onClick={onRetry}>
        Tentar novamente
      </BotaoRetry>
    </Container>
  );
}
